









import { Component, Mixins, Prop } from 'vue-property-decorator';
import DeleteConfirmation from '@/layouts/DeleteConfirmation.vue';
import Mixin from '@/mixins/base';
import { namespace } from 'vuex-class';
import { CounterData } from '@/modules/backend/Entities/CounterData';

const CountersDataModule = namespace('dashboard/countersData');

@Component({
  components: {
    DeleteConfirmation
  }
})
export default class CounterDataDeleteDialog extends Mixins(Mixin) {
  @Prop({
    required: true,
    type: Object
  })
  private readonly data!: CounterData;

  @CountersDataModule.Action('remove')
  private readonly remove!: (data: CounterData) => Promise<void>;

  private async performDataDelete(): Promise<void> {
    if (!this.data as unknown instanceof CounterData) {
      return;
    }
    await this.remove(this.data);
  }
}
